import ExtendedContent from "@/components/common/ExtendedContent";
import {useSetBannerDataFromRecapContent} from "@/hooks/useSetBannerData";
import SubPageBanner from "@/components/Banners/SubPage/SubPageBanner";
import WhatWeDoCategoryPageGridCards from "@/components/WhatWeDoCategoryPageGridCards";
import {useMemo} from "react";
import SeeAlso from "@/components/SeeAlso";
import {formatToCardItem} from "@/components/common/Cards";
import Recap, {getRecapDataFromData} from "@/components/Recap";
import {formatContentWithRecap} from "@/utils/utils";
import useGlobals from "@/hooks/useGlobals";


export default function WhatWeDoCategoryPageTemplate({data}) {
	const actions = data?.actions || []
	const content = data?.content || []
	const seeAlsoInfo = data?.seeAlsoInfo || {header: '', variant: ''}
	const isHorizontalAspect = data?.isHorizontalAspect || false;
	const formattedSeeAlsoData = useMemo(() => {
		const src = data?.seeAlsoLinks || []
		return src.map((item) => formatToCardItem(item))
	}, [data])
	const formattedContent = formatContentWithRecap(content);
	const bannerData = useSetBannerDataFromRecapContent(data)
	const uniqueActions = Array.from(
		new Map(actions.map(item => [item.id, item])).values()
	);
	return (
		<>
			<SubPageBanner data={bannerData}/>
			<Recap/>
			<ExtendedContent content={formattedContent}/>
			<WhatWeDoCategoryPageGridCards id='category-actions' horizontalCards={isHorizontalAspect} data={uniqueActions}/>
			<SeeAlso
				header={seeAlsoInfo.header}
				variant={seeAlsoInfo.variant}
				data={formattedSeeAlsoData}
				horizontalCards={isHorizontalAspect}
			/>
		</>
	)
}
